import { GlButton, GlTooltipDirective } from '../../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { n__, s__ } from '~/locale';
export default {
    name: 'DecisionLogHeaderButton',
    components: {
        GlButton
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    props: {
        count: {
            type: Number,
            required: false,
            default: 0
        },
        isPanelOpen: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    emits: [
        'open',
        'close'
    ],
    computed: {
        hasCount () {
            return this.count > 0;
        },
        ariaLabel () {
            if (!this.hasCount) return s__('WorkItemDecisionLog|Decision log');
            return n__('WorkItemDecisionLog|Decision log, %d decision', 'WorkItemDecisionLog|Decision log, %d decisions', this.count);
        }
    },
    methods: {
        onClick () {
            this.$emit(this.isPanelOpen ? 'close' : 'open');
        }
    }
};
